import { ReactComponent as Hurricane04 } from '@backrs_ui/common-ui/src/assets/customAppIcons/hurricane-04.svg';
import { ReactComponent as Hurricane05 } from '@backrs_ui/common-ui/src/assets/customAppIcons/hurricane-05.svg';
import { ReactComponent as US } from '@backrs_ui/common-ui/src/assets/customAppIcons/US.svg';
import { ColorToken, COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';
import { UNTITLED_UI_ICONS } from '@backrs_ui/common-ui/src/designSystem/icons/untitledUIIconList';

type UntitledUiIconNames = keyof typeof UNTITLED_UI_ICONS;

export const CUSTOM_ICON_NAMES = {
  Hurricane04: Hurricane04,
  Hurricane05: Hurricane05,
  US,
} as const;

type CustomIconNames = keyof typeof CUSTOM_ICON_NAMES;

// use strings for mapping so we get the autocomplete when using the component
export const ICON_SIZES = {
  '8px': '8px',
  '10px': '10px',
  '12px': '12px',
  '14px': '14px',
  '16px': '16px',
  '18px': '18px',
  '20px': '20px',
  '24px': '24px',
  '28px': '28px',
  '32px': '32px',
  '40px': '40px',
  '48px': '48px',
  '56px': '56px',
  '64px': '64px',
  '96px': '96px',
} as const;

export type IconSize = keyof typeof ICON_SIZES;

export type AppIcons = UntitledUiIconNames | CustomIconNames;

export type AppIconProps = Readonly<{
  /** if the icon you need is not listed in the autocomplete or throws an error, please import it in `untitledUIIconList.ts` */
  iconName: AppIcons;
  diameter: IconSize;
  /** choose from any DS color, or choose currentColor to take the color of the parent. This is useful for button icons */
  color: ColorToken | 'currentColor';
  rotate?: 0 | 90 | 180 | 270;
  fill?: ColorToken | 'currentColor';
  /** Stroke width in pixels. Defaults to 2.5px */
  strokeWidth?: 'thin' | 'regular' | 'bold';
}>;

export const AppIcon = ({
  iconName,
  diameter,
  color,
  rotate,
  fill,
  strokeWidth = 'regular',
}: AppIconProps) => {
  const IconComponent =
    iconName in UNTITLED_UI_ICONS
      ? UNTITLED_UI_ICONS[iconName as keyof typeof UNTITLED_UI_ICONS]
      : CUSTOM_ICON_NAMES[iconName as CustomIconNames];

  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      width={diameter}
      height={diameter}
      color={color === 'currentColor' ? 'currentColor' : COLOR_TOKENS[color]}
      transform={rotate ? `rotate(${rotate})` : undefined}
      className={strokeWidth ? `untitled-icon-stroke-width-${strokeWidth}` : ''}
      {...(fill ? { fill: fill === 'currentColor' ? 'currentColor' : COLOR_TOKENS[fill] } : {})}
    />
  );
};
